<template>
    <div id="chatbox">
        <div class="chat-wrapper p-3" ref="chatbox">
            <div v-if="isLoadingTop" class="text-center vert-center mb-3">
                <loader width="3rem" ></loader>
            </div>
            <div v-if="messages.length > 0">
                <div v-for="(m, idx) in messages" :key="idx">
                    <div :class="['col-10', 'p-3', 'mb-3', 'talk', 'chat', { 'offset-2 me': m.isMe }]" >
                        <div class="head">
                            <font-awesome-icon :icon="['far', 'comment']"></font-awesome-icon>&nbsp;
                            <strong>{{(m.isMe) ? 'U' : 'Ontvangen Bericht' }}</strong>
                        </div>
                        <div class="message mb-2">
                            <span v-html="m.message"></span>
                        </div>
                        <div class="foot mb-3">
                            <div class="float-left time d-inline-block invisible-sm">
                                {{m.send.toLocaleDateString()}} {{m.send.toLocaleTimeString()}} <span v-if="m.isRead && m.isMe">(gelezen)</span>&nbsp;<span v-if="m.toAll">(groepsbericht)</span>
                            </div>
                            <div class="float-right read d-inline-block invisible-sm" title="Gelezen" v-if="m.isRead && m.isMe">
                                <font-awesome-icon icon="check"></font-awesome-icon>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else-if="!isLoading" class="text-center vert-center no-messages">
                <h4>Nog geen berichten...</h4>
            </div>
            <div v-if="isLoading" class="text-center vert-center mb-3">
                <loader width="3rem" ></loader>
            </div>
        </div>
        <form class="chat-message-box row" @submit.prevent="sendMessage" v-if="!disabled">
            <div class="chat-message col-md-8">
                <textarea class="form-control" placeholder="Type hier uw bericht..." v-model="message.message" ></textarea>
            </div>
            <div class="chat-send col-md-4 d-flex align-items-end mt-3">
                <button type="submit" class="btn btn-azure-dark btn-wide float-right text-center align-items-end" :disabled="!message.message || disabled">Versturen</button>
            </div>
        </form>
        <div v-else class="chat-message-box text-center">
            <h3>Helaas u kunt geen berichten meer sturen.<br>De opdracht is voltooid.</h3>
        </div>
    </div>
</template>

<script>
import Loader from '@/components/Loader';
import { chatMessage } from '@/models/models.js';

export default {
    name: 'chat',
    components: {
        Loader
    },
    props: 
    {
        disabled: 
        {
            type: Boolean,
            required: false,
            default: false
        },
        assignmentId: 
        {
            type: Number,
            required: true,
        },
        userId: 
        {
            type: String,
            required: false,
            default: ''
        }
    },
    data() {
        return {
            isLoading: true,
            isLoadingTop: false,
            allLoaded: false,
            skip: 0,
            message: new chatMessage({ assignmentId: this.$route.params.id }),
            messages: []
        }
    },
    mounted() {
        this.isLoading = true;
        this.getMessages();

        this.$refs.chatbox.addEventListener('scroll', (ev) => {
            if(ev.currentTarget.scrollTop == 0 && !this.allLoaded)
            {
                this.isLoadingTop = true;
                this.skip += 10;
                this.getMessages().then((res) => {
                    if(res.data.length < 10)
                        this.allLoaded = true;
                })
            }
        })
    },
    methods: {
        scrollDown() {
            setTimeout(() => {
                const wrapper = document.querySelector("#chatbox .chat-wrapper");
                wrapper.scrollTo(0, wrapper.scrollHeight);
            },1);
        },
        getMessages() {
            return this.$http.get('api/Chat/' + this.assignmentId + "?skip=" + this.skip + "&to=" + this.userId).then((res) => {
                res.data.forEach((c) => {
                    this.messages.unshift(new chatMessage(c));
                });
                this.isLoading = false;
                this.isLoadingTop = false;

                if(this.skip == 0)
                    this.scrollDown();

                return res;
            }).catch(() => {
                this.messages = [];
                this.isLoading = false;
                this.isLoadingTop = false;
                this.scrollDown();
            });
        },
        sendMessage() {
            if(this.message ==  null)
                return;

            this.isLoading = true;
            this.scrollDown();
            this.message.message = this.message.message.replace(/\n\r?/g, '<br />');

            this.$http.post("api/Chat/" + this.assignmentId + "?to=" + this.userId, this.message).then((res) => {
                this.isLoading = false;
                this.messages.push(new chatMessage(res.data));
                this.message = new chatMessage({ assignmentId: this.$route.params.id });
                this.scrollDown();
            }).catch(() => {
                this.isLoading = false;
            });
        }
    },
    watch: {
        userId(to)
        {
            this.skip = 0;
            this.messages = [];
            this.getMessages();
        } 
    }
}
</script>

<style lang="scss">
#chatbox
{
    height: 100%;
    min-height: 500px;
    position:relative;

    .chat-wrapper {
        height: calc(100% - 100px);
        width: 100%;
        left: 0;
        overflow: auto;
        position: absolute;
        top: 0;
        //border: .5px solid lightgray;
        scroll-behavior: smooth;
        //border-left: 1px solid $darkColor;
        //border-top: 1px solid $darkColor;
        //border-right: 1px solid $darkColor;
        border: 1px solid $darkColor;

        .no-messages {
            color: lightgray;
        }

        .chat {
            border-radius: 5px;
            background-color: $darkColor;
            color: $lightColor;

            .foot {
                font-size: 12px;
            }
            .read {
                font-size: 12px;
                color: green;
            }

        }

        .chat.me {
            background-color: $lightColor;
            color: $darkColor;
        }

        .chat.talk {
            position:relative;
            height:100% !important;
            width:100% !important;
        }
        .chat.talk:after {
            content:'';
            position: absolute;
            top: 100%;
            width: 0;
            height: 0;
            border-top: solid 5px $darkColor;
            border-left: solid 5px transparent;
            border-right: solid 5px transparent;
        }
        .chat.talk:not(.me):after {
            left: 5%;
            margin-left: -5px;
        }
        .chat.talk.me:after {
            right: 5%;
            margin-right: -5px;
            border-top: solid 5px $lightColor;
        }

    }

    
    .chat-message-box {
        width: 100%;
        height: 100px;
        max-height: 100px;
        min-height: 10px;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        padding: 15px;
        position: absolute;
        background-color: $lightColor;
        border-left: 1px solid $darkColor;
        border-right: 1px solid $darkColor;
        border-bottom: 1px solid $darkColor;

        .form-control {
            color: $darkColor;
        }

        .chat-message textarea {
            height: 2.5rem;
            height: 70px;
            min-height: 70px;
            max-height: 70px;
        }
    }
}

</style>